import { types } from 'mobx-state-tree';

export default types.model('CreditCardSummary', {
  id: types.number,
  credit_card: types.string,
  credit_card_type: types.string,
  user_name: types.maybeNull(types.string),
  created_at: types.string,
});
